import { useState } from "react";
import { Badge, Button, Card, Col, Modal, Row } from "react-bootstrap";
import Styles from "../styles.module.scss";

type InfoCardProps = {
  name: string;
  src?: string;
  status: string;
  gender: string;
  species: string;
  location: string;
  origin: string;
  time: string;
  episode: number;
  index?: number;
};
const CharacterCard: React.FC<InfoCardProps> = ({
  name,
  src,
  status,
  gender,
  species,
  location,
  episode,
  origin,
  time
}) => {
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  return (
    <>
      <Col xs={12} md={6} lg={4} data-testid='character' className='py-3'>
        <Card className='position-relative'>
          <Card.Img variant='top' alt='characterImg' src={src} />
          <Card.Body>
            <h2 className={Styles.charName}>{name}</h2>
            <div className={Styles.badges}>
              <Badge
                variant={
                  status === "Alive"
                    ? "success"
                    : status === "unknown"
                    ? "warning"
                    : "danger"
                }>
                {status}
              </Badge>
              <Badge variant={gender === "Male" ? "info" : "light"}>
                {gender}
              </Badge>
              <Badge variant={species === "Human" ? "primary" : "secondary"}>
                {species}
              </Badge>
            </div>

            <p className={Styles.locationP}>
              <b> Location: </b> {location}
            </p>
            <p>
              Appears in <b> {episode}</b> episodes
            </p>

            <Button
              variant='success'
              data-testid='modalButton'
              onClick={handleShow}
              className={Styles.infoButton}>
              More info
            </Button>
          </Card.Body>
        </Card>
      </Col>

      <Modal
        show={show}
        onHide={handleClose}
        aria-labelledby='contained-modal-title-vcenter'
        centered>
        <Modal.Header closeButton>
          <Modal.Title>{name} </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Row>
            <Col>
              <img src={src} alt='' className='w-100 ' />
            </Col>
            <Col>
              <div className='justify-content-center h-100'>
                <h3 className={Styles.charName}>{name} </h3>
                <div className='mt-2 mb-3'>
                  <Badge
                    className='mr-2'
                    variant={
                      status === "Alive"
                        ? "success"
                        : status === "unknown"
                        ? "warning"
                        : "danger"
                    }>
                    {status}
                  </Badge>
                  <Badge
                    className='mr-2'
                    variant={gender === "Male" ? "info" : "light"}>
                    {gender}
                  </Badge>
                  <Badge
                    variant={species === "Human" ? "primary" : "secondary"}>
                    {species}
                  </Badge>
                </div>

                <p>
                  <b> Location: </b> {location}
                </p>
                <p>
                  <b> Was born in: </b> {origin}
                </p>
                <p>at: {time.slice(0, 10)} </p>
                <p>
                  Appears in <b> {episode}</b> episodes
                </p>
              </div>
            </Col>
          </Row>
        </Modal.Body>
        <Modal.Footer>
          <Button variant='secondary' onClick={handleClose}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default CharacterCard;
